import { Label } from '@optools/components/ui/label';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from '@optools/components/ui/select';
import { selectLoggerConfig } from '@optools/store/configApiSlice';
import { useAppSelector } from '@optools/store/hooks';
import { useId } from 'react';

import { createAdDurationsFromArray, generateAdDurationOptions } from '../utils/ad-durations';

export interface DurationOption {
  label: string;
  value: string;
}

export interface AdDurationSelectProps {
  adDuration: number;
  disabled?: boolean;
  setAdDuration: (adDuration: number) => void;
}

export function AdDurationSelect({ adDuration, disabled, setAdDuration }: AdDurationSelectProps) {
  const { adBreakDurations, commonBreakDurations } = useAppSelector(selectLoggerConfig);
  const id = useId();

  const onChangeAdDuration = (value: string) => {
    const newDuration = parseInt(value.replace(/^(common-|standard-)/, ''));
    if (!isNaN(newDuration)) {
      setAdDuration(newDuration);
    }
  };

  const { end, start, step } = adBreakDurations;
  const durations = generateAdDurationOptions(start, end, step);
  const commonDurations = createAdDurationsFromArray(commonBreakDurations);

  const defaultValue = `${commonDurations.find(({ value }) => value === adDuration) ? 'common' : 'standard'}-${adDuration}`;

  return (
    <div className="flex flex-col gap-1">
      <Label className="text-xs" htmlFor={id}>
        Ad Duration
      </Label>
      <Select defaultValue={defaultValue} disabled={disabled} onValueChange={onChangeAdDuration}>
        <SelectTrigger className="w-full" data-testid="adDurationSelect" id={id}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent align="center" avoidCollisions={false} side="top">
          {commonDurations.length > 0 && (
            <SelectGroup>
              <SelectLabel>Common</SelectLabel>
              {commonDurations.map(({ label, value }) => (
                <SelectItem key={`common-${value}`} value={`common-${value}`}>
                  {label}
                </SelectItem>
              ))}
              <SelectSeparator />
            </SelectGroup>
          )}
          <SelectGroup>
            <SelectLabel>All</SelectLabel>
            {durations.map(({ label, value }) => (
              <SelectItem key={`standard-${value}`} value={`standard-${value}`}>
                {label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
}
